var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16133 12H11.1173C11.4893 12 11.8413 11.82 12.0587 11.518L14.112 8.67067C14.4073 8.262 14.4067 7.712 14.11 7.30267L12.058 4.47933C11.84 4.17867 11.4887 4 11.1187 4H3.16133C2.52067 4 2 4.522 2 5.164V10.836C2 11.478 2.52067 12 3.16133 12ZM2.99533 5.164C2.99533 5.07267 3.06933 4.998 3.16133 4.998H11.1187C11.1727 4.998 11.2213 5.02267 11.2527 5.06667L13.3047 7.89067C13.3467 7.94867 13.3473 8.02733 13.3053 8.086L11.252 10.9333C11.22 10.9767 11.1713 11.002 11.1173 11.002H3.16133C3.06933 11.002 2.99533 10.928 2.99533 10.836V5.164ZM10.0327 7.49267C9.75867 7.49267 9.53533 7.71667 9.53533 7.99133C9.53533 8.266 9.75867 8.49067 10.0327 8.49067C10.3073 8.49067 10.5307 8.266 10.5307 7.99133C10.5307 7.71667 10.3073 7.49267 10.0327 7.49267ZM8.53933 7.99133C8.53933 8.81733 9.20933 9.488 10.0327 9.488C10.856 9.488 11.526 8.81733 11.526 7.99133C11.526 7.16667 10.856 6.49467 10.0327 6.49467C9.20933 6.49467 8.53933 7.16667 8.53933 7.99133Z",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.b1976cc37d249ceb5d4911aaaebbbdc4.svg";
export { ForwardRef as ReactComponent };